/* EI Product v4 — gallery + sticky add-to-cart */
(function () {
  'use strict';

  function initGallery(root) {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.ei-product__gallery-slide');
    if (slides.length < 2) return;

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var counter = gallery.querySelector('[data-gallery-current]');
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
      if (counter) counter.textContent = (index + 1).toString();
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  }

  function initSticky(root) {
    var sticky = document.querySelector('.sticky_addcart');
    var heroCta = root.querySelector('[data-cta-hero]');
    if (!sticky || !heroCta) return;

    /* Sprint 2026-06-07 — Inversion logique CTA above-the-fold mobile.
       AVANT (bug #6 fix du 2026-05-08) : sticky caché tant que hero CTA visible
       (≥30%). Problème : sur iPhone base + Android médian, le hero CTA est
       below-the-fold à l'atterrissage donc oui le sticky apparaissait, mais
       avec un délai (le temps que IntersectionObserver fire au scroll).
       APRÈS : sticky visible par défaut sur mobile (CSS), on AJOUTE la classe
       `is-hero-cta-in-view` quand le hero CTA est ≥30% visible pour le cacher.
       Résultat : à l'atterrissage le sticky est déjà là (CSS first paint), on
       le cache seulement si l'utilisateur voit déjà le hero CTA. */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-hero-cta-in-view', e.isIntersecting);
      });
    }, { threshold: 0.3 });

    observer.observe(heroCta);
  }

  function initReadMore(root) {
    // Pattern "Lire plus" sur la description (variante B charte v10.2)
    // - Si le texte n'est pas assez long pour être tronqué : on retire .is-collapsed et on masque le bouton.
    // - Sinon : on toggle .is-collapsed au clic + bascule des labels Lire plus / Réduire.
    //
    // ⚠️ Timing : on mesure scrollHeight vs clientHeight, MAIS si on mesure trop tôt (avant que
    // les Google Fonts soient chargées), le navigateur utilise une font système plus compacte
    // → le texte "tient" → bouton masqué à tort. Solution : attendre fonts.ready + window.load.
    var wrappers = root.querySelectorAll('[data-readmore]');

    function setup(wrap) {
      var body = wrap.querySelector('[data-readmore-body]');
      var toggle = wrap.querySelector('[data-readmore-toggle]');
      if (!body || !toggle) return;

      var labelMore = toggle.querySelector('[data-readmore-label-more]');
      var labelLess = toggle.querySelector('[data-readmore-label-less]');

      function measure() {
        // On force is-collapsed pendant la mesure pour comparer scrollHeight (texte total)
        // vs clientHeight (texte tronqué par max-height CSS).
        wrap.classList.add('is-collapsed');
        var needsTruncation = body.scrollHeight > body.clientHeight + 4;
        if (!needsTruncation) {
          wrap.classList.remove('is-collapsed');
          toggle.hidden = true;
        } else {
          toggle.hidden = false;
        }
      }

      // Mesure immédiate (cas où les fonts sont déjà en cache) + après fonts ready + après window.load.
      measure();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measure);
      }
      window.addEventListener('load', measure);
      // Re-mesure si on resize (passage desktop ↔ mobile change le max-height CSS).
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(measure, 150);
      });

      toggle.addEventListener('click', function () {
        var collapsed = wrap.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', String(!collapsed));
        if (labelMore && labelLess) {
          labelMore.hidden = !collapsed;
          labelLess.hidden = collapsed;
        }
      });
    }

    wrappers.forEach(setup);
  }

  function formatMoney(cents) {
    // Format simple EUR : "€42,85". Si Shopify.formatMoney est dispo (theme legacy), on l'utilise.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, '€{{amount}}'); } catch (e) {}
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  function initFBT(root) {
    // Bloc 9 — Frequently Bought Together (style Amazon)
    // - Recalcule total à chaque change de checkbox
    // - Bouton "+" individuel : ajout solo via /cart/add.js
    // - Bouton "Tout ajouter" : ajout multiple via /cart/add.js {items: [...]}
    var fbt = root.querySelector('[data-fbt]');
    if (!fbt) return;

    var rows = fbt.querySelectorAll('[data-fbt-row]');
    var totalEl = fbt.querySelector('[data-fbt-total]');
    var ctaAll = fbt.querySelector('[data-fbt-add-all]');

    function getCheckedItems() {
      var items = [];
      rows.forEach(function (row) {
        var check = row.querySelector('[data-fbt-check]');
        if (check && check.checked) {
          items.push({
            id: parseInt(row.getAttribute('data-variant-id'), 10),
            price: parseInt(row.getAttribute('data-price'), 10) || 0
          });
        }
      });
      return items;
    }

    function recalcTotal() {
      var items = getCheckedItems();
      var sum = items.reduce(function (acc, it) { return acc + it.price; }, 0);
      if (totalEl) totalEl.textContent = formatMoney(sum);
      if (ctaAll) ctaAll.disabled = items.length === 0;
    }

    function addToCart(payload, button) {
      // payload = {id, quantity} OU {items: [...]}
      if (button) button.classList.add('is-loading');
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart add failed: ' + r.status);
          return r.json();
        })
        .then(function (data) {
          // Notifier le reste du theme (mini-cart, badge panier…) que le panier a changé
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          // Apps de panier classiques écoutent aussi ces events
          document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad'));
          return data;
        })
        .finally(function () {
          if (button) button.classList.remove('is-loading');
        });
    }

    // Recalcul initial + écoute des checkboxes
    recalcTotal();
    rows.forEach(function (row) {
      var check = row.querySelector('[data-fbt-check]');
      if (check) check.addEventListener('change', recalcTotal);

      // Bouton "+" individuel — stopPropagation pour éviter de toggler la checkbox du label parent
      var addOne = row.querySelector('[data-fbt-add-one]');
      if (addOne) {
        addOne.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
          if (!variantId) return;
          addToCart({ id: variantId, quantity: 1 }, addOne)
            .then(function () {
              addOne.classList.add('is-added');
              addOne.innerHTML = '<span aria-hidden="true">✓</span>';
              setTimeout(function () {
                addOne.classList.remove('is-added');
                addOne.innerHTML = '<span aria-hidden="true">+</span>';
              }, 1800);
              // Tente d'ouvrir le mini-cart s'il existe (app Shopify courante)
              var miniCartTrigger = document.querySelector('[data-cart-toggle], .cart-icon, .header-cart');
              if (miniCartTrigger && typeof miniCartTrigger.click === 'function') {
                // commenté volontairement : laisse l'app cart gérer son propre comportement
              }
            })
            .catch(function (err) {
              console.warn('[EI FBT] add one failed', err);
              alert('Impossible d\u2019ajouter ce produit au panier. Réessayez.');
            });
        });
      }
    });

    // CTA "Tout ajouter"
    if (ctaAll) {
      ctaAll.addEventListener('click', function () {
        var items = getCheckedItems();
        if (items.length === 0) return;
        var payload = { items: items.map(function (it) { return { id: it.id, quantity: 1 }; }) };
        addToCart(payload, ctaAll)
          .then(function () {
            var label = ctaAll.querySelector('.ei-product__fbt-cta-label');
            var originalLabel = label ? label.textContent : '';
            if (label) label.textContent = 'Ajouté ✓';
            setTimeout(function () {
              if (label) label.textContent = originalLabel;
            }, 1800);
          })
          .catch(function (err) {
            console.warn('[EI FBT] add all failed', err);
            alert('Impossible d\u2019ajouter les produits au panier. Réessayez.');
          });
      });
    }
  }

  function init() {
    var root = document.querySelector('.ei-product');
    if (!root) return;
    initGallery(root);
    initSticky(root);
    initReadMore(root);
    initFBT(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
